import { Paginator, PageContainer, Page, Metadata } from './styles'

Paginator.PageContainer = PageContainer
Paginator.Page = Page
Paginator.Metadata = Metadata

export default Paginator
